export var ColorScheme;
(function (ColorScheme) {
    ColorScheme["Dark"] = "dark";
    ColorScheme["SystemDark"] = "dark:system";
    ColorScheme["Light"] = "light";
    ColorScheme["SystemLight"] = "light:system";
})(ColorScheme || (ColorScheme = {}));
